// src/db/visitorCheckoutQRApi.js
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Fetch visit details by ID
 * @param {string} visitId
 * @returns {Promise<Object|null>}
 */
export const getVisitById = async (visitId) => {
  try {
    if (!visitId) return null;
    const visitRef = doc(db, 'visit_approvals', visitId);
    const visitSnap = await getDoc(visitRef);
    if (!visitSnap.exists()) return null;

    return { id: visitSnap.id, ...visitSnap.data() };
  } catch (error) {
    console.error('Error fetching visit by ID:', error);
    throw error;
  }
};

/**
 * Fetch visitor details by user ID
 * @param {string} visitorUserID
 * @returns {Promise<Object|null>}
 */
export const getVisitorById = async (visitorUserID) => {
  try {
    if (!visitorUserID) return null;
    const visitorRef = doc(db, 'users', visitorUserID);
    const visitorSnap = await getDoc(visitorRef);
    if (!visitorSnap.exists()) return null;

    return { id: visitorSnap.id, ...visitorSnap.data() };
  } catch (error) {
    console.error('Error fetching visitor by ID:', error);
    throw error;
  }
};
